import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1875686809790415';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.fbq) {
      window.fbq('track', 'PageView');
      return;
    }
    // Standard Meta Pixel base code
    ;
    (function (f: any, b: Document, e: string, v: string) {
      let n: any, t: HTMLScriptElement, s: HTMLScriptElement | Element | null;
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e) as HTMLScriptElement;
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s && s.parentNode && s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-69">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-70" />
    </noscript>;
}